import { Box, Divider, TextInput } from "@mantine/core";
import { useAtom, useAtomValue } from "jotai";

import Button from "components/Button";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { firstNamePhAtom, lastNamePhAtom, personalCodePhAtom } from "atoms/phPersonalDetails";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useDigitalJourneyPageRouting } from "hooks/useDigitalJourneyPageRouting";
import { useEventTracking } from "hooks/useEventTracking";

export const DJPersonalDetailsPHPage = () => {
  const { t } = useClientTranslation();
  const { trackEvent } = useEventTracking();
  const { onNext, continueCTA } = useDigitalJourneyPageRouting();
  const [firstNamePh, setFirstNamePh] = useAtom(firstNamePhAtom);
  const [lastNamePh, setLastNamePh] = useAtom(lastNamePhAtom);
  const [personalCodePh, setPersonalCodePh] = useAtom(personalCodePhAtom);

  const fiscalCodeError = personalCodePh && personalCodePh.length !== 16
    ? "Il codice fiscale deve essere di 16 caratteri"
    : undefined;
  const isDisabled = !firstNamePh || !lastNamePh || !!fiscalCodeError;

  const onContinue = () => {
    trackEvent({ name: "Digital Journey Policy Holder Personal Details - continue" });
    onNext();
  };

  return (
    <PageLayout contentSpacing="space-between">
      <Flex px={24} py={24} gap={16} flex={1} mb={16}>
        <Box mb={24}>
          <Text as="h1" sizeVariant="xl" weight={600}>
            Informazioni sul conducente
          </Text>
          <Text style={{ color: "#484848" }}>Inserisci le informazioni relative al conducente.</Text>
        </Box>
        <Flex>
          <Text mb={8} style={{ color: "#484848" }}>
            Dettagli del conducente
          </Text>
          <Divider mb={16} size="xs" style={{ borderColor: "#D9D9D9" }} />
          <Flex gap={24}>
            <TextInput
              name="firstNamePh"
              value={firstNamePh}
              label={
                <Text weight={700} sizeVariant="md">
                  Nome*
                </Text>
              }
              onChange={(e) => setFirstNamePh(e.target.value)}
            />
            <TextInput
              name="lastNamePh"
              value={lastNamePh}
              label={
                <Text weight={700} sizeVariant="md">
                  Cognome*
                </Text>
              }
              onChange={(e) => setLastNamePh(e.target.value)}
            />
            <TextInput
              name="personalCodePh"
              value={personalCodePh}
              label={
                <Text weight={700} sizeVariant="md">
                  Codice Fiscale
                </Text>
              }
              onChange={(e) => setPersonalCodePh(e.target.value)}
              error={fiscalCodeError}
              maxLength={16}
            />
          </Flex>
        </Flex>
      </Flex>
      <Flex px={24} py={24} gap={16}>
        <Button disabled={isDisabled} onClick={onContinue}>
          {continueCTA}
        </Button>
      </Flex>
    </PageLayout>
  );
};
